/// nome das paginas 

export default class PagesName{

 autionList ="autionList";
 addAution ="addAution";
 dashboardPage ="dashboardPage";
 addAnaucements ="addAnaucements";
 AnaucementsList ="anaucementList";
 criarconta ="criarconta";
 login ="login";
 privacy ="PrivacyPolicy";
 LandingPage = "LandingPage"
 HowItsWorks = "HowItsWorks"
 Homepage = "HomePage"
 useritemanaucement = "useritemanaucement"
 autiondetailuser = "autiondetailuser"
}